import _taggedTemplateLiteral from "/codebuild/output/src4034959427/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React, { createElement } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { basePropTypes, handleProps } from './utils';
import propsToCss from '../utils/propsToCss';
const StyledIconButton = styled(IconButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  ", "\n"])), props => propsToCss(props));
const IconButtonGy = props => {
  const {
    label,
    tooltip,
    className,
    icon,
    visible,
    ...rest
  } = props;
  if (visible === false) {
    return null;
  }
  const content = /*#__PURE__*/React.createElement(StyledIconButton, _extends({
    "aria-label": label,
    className: className
  }, handleProps(rest)), icon && /*#__PURE__*/createElement(icon), rest.children);
  if (!label && !tooltip || rest.disabled) {
    return content;
  }
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: label || tooltip
  }, content);
};
IconButtonGy.propTypes = {
  ...basePropTypes,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  children: PropTypes.any,
  label: PropTypes.string
};
export default IconButtonGy;